import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem as DropDownItem
} from "MODULES/shared/components/DropDown";
import ConfirmDelete from "MODULES/shared/components/ConfirmDelete";
import { connect } from "react-redux";
import {
  returnToCustomer,
  updateLineItem
} from "MODULES/ManagedRepairOrders/actions";
import { RESERVE_FOR_REPAIR } from "MODULES/inventories/constants";
import { ConfirmAction } from "MODULES/shared/components";

function Controls({ cancelItem, lineItem, returnItem }) {
  return (
    <DropDown>
      {!lineItem.cancelled &&
        !lineItem.received && (
          <DropDownItem
            id="cancel"
            label="Cancel"
            faIcon="ban"
            renderActive={
              <ConfirmDelete
                onConfirm={cancelItem}
                message="Are you sure you want to cancel?"
              />
            }
          />
        )}
      {!lineItem.shipped &&
        get(lineItem, "inventory.repair_status") === RESERVE_FOR_REPAIR &&
        lineItem.received &&
        !lineItem.return_to_customer_without_repairing && (
          <DropDownItem
            id="cancel"
            label="Return To Customer"
            faIcon="ban"
            renderActive={
              <ConfirmAction
                onConfirm={returnItem}
                message="Are you sure you want to return?"
              />
            }
          />
        )}
    </DropDown>
  );
}

Controls.propTypes = {
  cancelItem: PropTypes.func.isRequired,
  lineItem: PropTypes.shape({}),
  returnItem: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, { lineItem: { id } }) => ({
  cancelItem: () => dispatch(updateLineItem(id, { cancelled: true })),
  returnItem: () => dispatch(returnToCustomer(id))
}))(Controls);



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/LineItemsTable/Controls/Controls.jsx